import React from 'react';
import cn from 'classnames';

import styles from './style.scss';

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
interface Props {
  title: string;
  className?: string;
  isChecked?: boolean;
  isPartialChecked?: boolean;
  isSmall?: boolean;
  label?: string;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const Checkbox = ({
  isChecked = false,
  isPartialChecked = false,
  isSmall = false,
  title,
  className = '',
  label = '',
  onClick,
}: Props) => (
  <div
    className={cn(styles.checkbox, className)}
    data-test="checkbox"
    onClick={onClick}
  >
    <div
      className={cn('checkbox-label', {
        checked: isChecked,
        'partial-checked': isPartialChecked,
        small: isSmall,
      })}
      data-test="checkbox-label"
      title={title}
    />
    <span className={styles.text}>{label}</span>
  </div>
);

export default Checkbox;
